import { ModalConfig } from '@shared/interfaces/modal/modal-config';
import {
  MeterAddQuadrantMappingComponent
} from '@shared/modals/meter/meter-add-quadrant-mapping/meter-add-quadrant-mapping.component';

export const meterAddQuadrantMappingModalConfig: ModalConfig = {
  component: MeterAddQuadrantMappingComponent,
  title: 'quadrantMappingModal.title',
  actions: [
    {
      type: 'primary',
      label: 'system.button.save',
      method: 'submit',
    },
    {
      type: 'secondary',
      label: 'system.button.cancel',
      closeOnClick: true,
    },
  ],
};
